<template>
    <div>
        <div class="question-type-item" v-for="(questionItem, questionIndex) in data">
            <div class="question-type-title" v-if="questionItem.length > 0">
                <span class="title">{{getQtype(questionIndex)}}</span>
                <span class="subtitle">(共{{questionItem | countArr}}题， 共{{questionItem | countScore}}分)</span>
            </div>
            <div class="subject-item" v-for="(subjectItem, subjectIndex) in questionItem">
                <div class="subject-title">
                    <span>{{subjectIndex + 1}}.</span>
                    <span class="score">({{subjectItem.score}}分)</span>
                    <span class="title" v-html="subjectItem.topic.title"></span>
                </div>
                <el-radio-group v-model="subjectItem.stu_answer" class="subject-answer" v-if="subjectItem.topic_type === 1 || subjectItem.topic_type === 3">
                    <el-radio :label="optionIndex" class="answer-item" v-for="(optionItem, optionIndex) in subjectItem.topic.options.option">
                        {{optionIndex + 1 | formatNumber}}、{{optionItem.name}}
                    </el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="subjectItem.stu_answer" class="subject-answer" v-if="subjectItem.topic_type === 2">
                    <el-checkbox :label="optionIndex"  class="answer-item" v-for="(optionItem, optionIndex) in subjectItem.topic.options.option">
                        {{optionIndex + 1 | formatNumber}}、{{optionItem.name}}
                    </el-checkbox>
                </el-checkbox-group>
                <div class="subject-answer" v-if="subjectItem.topic_type === 4">
                    <div class="textarea-box" v-for="(optionItem, optionIndex) in subjectItem.stu_answer">
                        <span>({{optionIndex + 1}})&nbsp;&nbsp;</span>
                        <el-input  v-model="subjectItem.stu_answer[optionIndex]" @input="inputOnInput()" placeholder="请输入答案" style="width: 400px"></el-input>
                    </div>
                </div>
                <div class="subject-answer" v-if="subjectItem.topic_type === 5">
                    <div class="textarea-box">
                        <el-input type="textarea" :rows="5" class="textarea-box" placeholder="请输入答案" style="width: 400px" v-model="subjectItem.stu_answer"></el-input>
                    </div>
                </div>
                <div class="true-answer-content" v-if="status">
                    <div class="answer-content" v-if="Number(subjectItem.topic_type) !== 5 ">
                        正确答案： {{ subjectItem | formatTrueAnswer }}
                    </div>
                    <div class="answer-content" v-else>
                        <p v-html="subjectItem.topic.analyse"></p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'underscore';
    import functions from "@/utils/common";
    export default {
        name: "examPaperTemplate",
        props: {
            data: Object,
            status: {
                type: Number,
                default: 0
            }
        },
        watch: {
            property: {
                immediate: true,
                handler() {
                }
            },
            data(newVal, oldVal) {
                // this.formatAnswerData(newVal)
            }
        },
        data() {
            return {
                singleOption: [],
                multiOption: [],
                fillBlankOption: [],
                askAnswerOption: []
            }
        },
        mounted() {
        },
        filters: {
            countArr(value) {
                return value.length;
            },
            countScore(value) {
                let total = 0;
                for(let i=0; i<value.length; i++) {
                    total += parseInt(value[i].score);
                }
                return total;
            },
            formatNumber(value) {
                return functions.formatAlph(value);
            },
            formatTrueAnswer: function(topicItem) {
                const options = ["A","B","C","D"];
                if (topicItem.topic_type === 1) {
                    return options[topicItem.topic.options.value]
                }

                if (topicItem.topic_type === 2) {
                    let list = topicItem.topic.options.value.map(val => {
                        return options[val];
                    })
                    return list.join("、")
                }

                if (topicItem.topic_type === 3) {
                    return topicItem.topic.options.option[topicItem.topic.options.value].name;
                    // return topicItem.topic.options.value === 0 ? "错" : "对"
                }

                if (topicItem.topic_type === 4) {
                    if (topicItem.topic.options.option[0].name) {
                        return topicItem.topic.options.option.map(item => item.name).join("、")
                    }
                    return topicItem.topic.options.option.join("、")
                }
                return topicItem.topic.analyse ?? "暂无解析"

            }
        },
        methods: {
            inputOnInput(e) {
                this.$forceUpdate();
            },
            formatAnswerData(topicList) {
                if (topicList.single && topicList.single.length) {
                    topicList.single.forEach(item => {
                        this.singleOption[item.id] = ""
                    })
                }
                if (topicList.multiple && topicList.multiple.length) {
                    topicList.multiple.forEach(item => {
                        console.log("item", item)
                        this.multiOption[item.id] = [];
                    })
                }
                if (topicList.judge && topicList.judge.length) {
                    topicList.judge.forEach(item => {
                        this.singleOption[item.id] = "";
                    })
                }
                if (topicList.fillBlank && topicList.fillBlank.length) {
                    topicList.fillBlank.forEach(item => {
                        this.fillBlankOption[item.id] = [];
                        item.topic.options.option.forEach(val => {
                            this.fillBlankOption[item.id].push("")
                        })
                    })
                }
                if (topicList.askAnswer && topicList.askAnswer.length) {
                    topicList.askAnswer.forEach(item => {
                        this.askAnswerOption[item.id] = ""
                    })
                }
                console.log("fillbak", this.fillBlankOption)
            },
            getQtype(value) {
                let indexStr = '';
                switch (value) {
                    case 'single':
                        indexStr = functions.translateNumberByObject(this.data, 'single');
                        return `${indexStr}、单选题`;
                        break;
                    case 'multiple':
                        indexStr = functions.translateNumberByObject(this.data, 'multiple');
                        return `${indexStr}、多选题`;
                        break;
                    case 'judge':
                        indexStr = functions.translateNumberByObject(this.data, 'judge');
                        return `${indexStr}、判断题`;
                        break;
                    case 'fillBlank':
                        indexStr = functions.translateNumberByObject(this.data, 'fillBlank');
                        return `${indexStr}、填空题`;
                        break;
                    case 'askAnswer':
                        indexStr = functions.translateNumberByObject(this.data, 'askAnswer');
                        return `${indexStr}、问答题`;
                        break;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .true-answer-content {
        &, &* {
            box-sizing: border-box;
        }
        background-color: #F8F9FA;
        border-radius: 5px;
        padding: 10px;
        margin: 10px 0;
        .answer-content {
            color: #3BC080
        }
    }
    .question-type-item {
        margin-bottom: 20px;
        .question-type-title {
            background: rgba(0,110,255,0.1);
            height: 48px;
            display: flex;
            align-items: center;
            padding: 0 40px ;
            box-sizing: border-box;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            // .title {
            //     color: #333;
            //     font-size: 18px;
            //     font-weight: 500;
            // }
            // .subtitle {
            //     font-size: 16px;
            //     color: #666;
            // }
        }
        .subject-item {
            &:deep(.el-radio-group) {
                .el-radio__input {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .el-radio {
                    margin-right: 30px;
                }
            }
            padding: 0 40px ;
            box-sizing: border-box;
            margin-top: 10px;
            padding-bottom: 20px;
            .subject-title {
                color: #333;
                font-size: 16px;
                font-weight: 500;
                .title {
                    ::v-deep p {
                        margin: 0;
                        display: inline;
                    }
                }
                .score {
                    color: #666;
                    opacity: 0.7;
                    margin: 0 10px;
                }
            }
            .subject-answer {
                display: block;
                margin-top: 15px;
                padding-left: 20px;
                .answer-item {
                    margin-top: 6px;
                    display: flex;
                    ::v-deep .el-radio__label {
                        width: 1%;
                        flex: 1;
                        white-space: normal;
                        line-height: 1.3;
                    }
                }
                .textarea-box {
                    margin-bottom: 10px;
                }
            }
        }
    }
::v-deep .el-input__inner{
    width: 779px !important;
}
</style>
